export default __webpack_public_path__ + "static/media/Independent Work.b63b0b8e.jpg";